import React, { useEffect, useState } from "react";
import { Col, Row, Typography, Avatar, message } from "antd";
import { connect, useSelector } from "react-redux";
import {
  getClientPersonalDetails,
  updateClientDetails,
} from "../Redux/client/reducer";
import profile from "../../images/profile.svg";
import Feedback from "../Utilities/Feedback";
import Icon from "@ant-design/icons";
import CameraIcon from "../Utilities/CameraIcon";

import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Formik } from "formik";
import {
  FormikInput,
  SelectCountry,
  FormikSubmitButton,
  FormikTextArea,
  FormikResetButton,
} from "../FormItems";
import { Form } from "formik-antd";
import * as Yup from "yup";
import { StyledUpload } from "../styled-components/components";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  mobileNumber: Yup.string().required("Phone Number is Required"),
  country: Yup.string().required("Country is required"),
});

const ClientAccount = (props) => {
  const { getUserInfo, updateDetails } = props;
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  useEffect(() => {
    const fetchUserInfo = async () => {
      await getUserInfo();
      setLoading(false);
    };
    fetchUserInfo();
  }, [getUserInfo]);
  const { userDetails } = useSelector((state) => state.userStore);
  const token = localStorage.getItem("token");
  const uploadProps = {
    name: "image_file",
    action: `${process.env.REACT_APP_BASE_URL}/upload-image`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    method: "put",
    showUploadList: false,
    async onChange(info) {
      if (info.file.status === "done") {
        message.loading("Updating Your Profile", 5);
        const { data } = info.file.response;
        const {
          firstName,
          lastName,
          mobileNumber,
          address,
          jobTitle,
          bankName,
        } = userDetails;
        const country = userDetails.Country;
        const profileImageId = data.imageId;
        await updateDetails(
          firstName,
          lastName,
          mobileNumber,
          country,
          jobTitle,
          bankName,
          address,
          profileImageId
        );
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  const initialValues = {
    firstName: userDetails ? userDetails.firstName : "",
    lastName: userDetails ? userDetails.lastName : "",
    jobTitle: userDetails ? userDetails.jobTitle : "",
    bankName: userDetails ? userDetails.bankName : "",
    mobileNumber: userDetails
      ? userDetails.mobileNumber
        ? Number(userDetails.mobileNumber.split(" ")[1])
        : "+91"
      : "+91",
    country: userDetails
      ? userDetails.Country
        ? userDetails.Country
        : "India"
      : "India",
    address: userDetails ? userDetails.address : "",
  };
  const [countryCode, setCountryCode] = useState(
    userDetails
      ? userDetails.mobileNumber
        ? Number(userDetails.mobileNumber.split(" ")[0])
        : ""
      : ""
  );
  const getCountryCode = (value) => {
    setCountryCode(value);
  };
  const updateUserDetails = async (details, actions) => {
    setUpdating(true);
    details.mobileNumber = `${countryCode} ${details.mobileNumber}`;
    const {
      firstName,
      lastName,
      mobileNumber,
      address,
      country,
      jobTitle,
      bankName,
    } = details;
    const { profileImageId } = userDetails;
    await updateDetails(
      firstName,
      lastName,
      mobileNumber,
      country,
      jobTitle,
      bankName,
      address,
      profileImageId
    );
    actions.setSubmitting(false);
    setUpdating(false);
  };
  const resetData = (values, actions) => {
    actions.resetForm(values);
  };
  return (
    <Col>
      <Col xl={{ span: 24 }} style={{ margin: "auto" }}>
        {loading ? (
          <Col
            style={{
              background: "#ffffff",
              padding: "4vh",
            }}
          >
            <Feedback
              icon={<Loading3QuartersOutlined spin />}
              title="Fetching Details"
            />
          </Col>
        ) : (
          <Col
            xl={{ span: 24 }}
            style={{
              background: "#ffffff",
              padding: "4vh",
            }}
          >
            <Col>
              <Col>
                <Row>
                  <Typography.Title level={5}>Edit Profile</Typography.Title>
                </Row>
                <Col xl={{ span: 16 }}>
                  <Row justify="center" style={{ marginBottom: "1vh" }}>
                    {userDetails && userDetails.profileImageUrl ? (
                      <Col>
                        <Col
                          style={{
                            zIndex: 1,
                            opacity: 0.8,
                          }}
                        >
                          <Avatar
                            src={userDetails.profileImageUrl}
                            size={144}
                          />
                        </Col>
                        <Col
                          style={{
                            position: "absolute",
                            zIndex: 2,
                            top: "15vh",
                            left: "14vh",
                            color: "#0A4C86",
                          }}
                        >
                          <StyledUpload {...uploadProps}>
                            <Icon component={CameraIcon}></Icon>
                          </StyledUpload>
                        </Col>
                      </Col>
                    ) : (
                      <Col>
                        <Col
                          style={{
                            marginBottom: "2vh",
                            zIndex: 1,
                            opacity: 0.8,
                          }}
                        >
                          <Avatar src={profile} size={144} />
                        </Col>
                        <Col
                          style={{
                            position: "absolute",
                            zIndex: 2,
                            top: "15vh",
                            left: "14vh",
                            color: "#0A4C86",
                          }}
                        >
                          <StyledUpload {...uploadProps}>
                            <Icon component={CameraIcon}></Icon>
                          </StyledUpload>
                        </Col>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col xl={{ span: 16 }}>
                  <Col xs={{ span: 24 }}>
                    {updating ? (
                      <Col>
                        <Feedback
                          title="Updating Your Details"
                          icon={<Loading3QuartersOutlined spin />}
                        />
                      </Col>
                    ) : (
                      <Formik
                        initialValues={initialValues}
                        validateOnMount
                        validationSchema={validationSchema}
                        onSubmit={updateUserDetails}
                        onReset={resetData}
                      >
                        {(formik) => {
                          return (
                            <Form>
                              <Row justify="space-between">
                                <Col xs={{ span: 8 }}>
                                  <FormikInput
                                    id="firstName"
                                    name="firstName"
                                    label="First Name"
                                    placeholder="Enter First name"
                                    value={initialValues.firstName}
                                  ></FormikInput>
                                </Col>

                                <Col xs={{ span: 14 }}>
                                  <FormikInput
                                    id="lastName"
                                    label="Last Name"
                                    name="lastName"
                                    placeholder="Enter Last name"
                                    value={initialValues.lastName}
                                  ></FormikInput>
                                </Col>
                              </Row>
                              <Row justify="space-between">
                                <Col xs={{ span: 8 }}>
                                  <SelectCountry
                                    id="selectCountry"
                                    label="Select Country"
                                    name="country"
                                    placeholder="Select Country"
                                    value={initialValues.country}
                                    getCountryCode={getCountryCode}
                                  />
                                </Col>
                                <Col xs={{ span: 14 }}>
                                  <FormikInput
                                    id="mobileNumber"
                                    label="Mobile Number"
                                    name="mobileNumber"
                                    type="number"
                                    placeholder="Enter Mobile Number"
                                    prefix={countryCode}
                                    value={initialValues.mobileNumber}
                                  ></FormikInput>
                                </Col>
                              </Row>
                              <Row justify="space-between">
                                <Col xs={{ span: 8 }}>
                                  <FormikInput
                                    id="bankName"
                                    label="Bank Name"
                                    placeholder="Enter Bank Name"
                                    name="bankName"
                                  ></FormikInput>
                                </Col>
                                <Col xs={{ span: 14 }}>
                                  <FormikInput
                                    id="jobTitle"
                                    label="Job Title"
                                    placeholder="Enter Job Title"
                                    name="jobTitle"
                                    value={initialValues.jobTitle}
                                  ></FormikInput>
                                </Col>
                              </Row>
                              <Col xs={{ span: 24 }}>
                                <FormikTextArea
                                  id="address"
                                  name="address"
                                  label="Address"
                                  placeholder="Enter Address"
                                  value={initialValues.address}
                                />
                              </Col>
                              <Row justify="space-between">
                                <Col xl={{ span: 6 }}>
                                  <FormikResetButton
                                    id="cancel-update"
                                    name="Cancel"
                                  ></FormikResetButton>
                                </Col>
                                <Col xl={{ span: 8 }}>
                                  <FormikSubmitButton
                                    id="submit-updateProfile"
                                    disabled={!formik.isValid}
                                    name="Update"
                                  />
                                </Col>
                              </Row>
                            </Form>
                          );
                        }}
                      </Formik>
                    )}
                  </Col>
                </Col>
              </Col>
            </Col>
          </Col>
        )}
      </Col>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserInfo: () => dispatch(getClientPersonalDetails()),
    updateDetails: (
      firstName,
      lastName,
      mobileNumber,
      country,
      jobTitle,
      bankName,
      address,
      profileImageId
    ) =>
      dispatch(
        updateClientDetails(
          firstName,
          lastName,
          mobileNumber,
          country,
          jobTitle,
          bankName,
          address,
          profileImageId
        )
      ),
  };
};

export default connect(null, mapDispatchToProps)(ClientAccount);
